import { componentName, SecurityQuestionsVerifyClass } from './SecurityQuestionsVerifyClass';
import '@descope-ui/descope-text';
import '../descope-text-field';

customElements.define(componentName, SecurityQuestionsVerifyClass);

export { SecurityQuestionsVerifyClass, componentName };
